import { event } from './EventEmmiter';
import nativeInterface from './native';
import { readStore } from '../mobx/stores/rf';
import { isAndroid } from '../upgrade';

export function downloadUpgradeFile(type, url, md5) {
  return event.execute({
    max: 1,
    interval: 5000,
    noSession: true,
    step: 'downloadUpgradeFile',
    executeFn() {
      const localAppVersion = localStorage.getItem('app_version');
      // 兼容旧版app，原生
      if (isAndroid() && localAppVersion < 18) {
        return nativeInterface.downloadUpgradeFile(
          type,
          url,
          md5
        );
      }
      return nativeInterface.downloadUpgradeFile(
        type,
        url,
        md5,
        readStore.projectParam.communicateType.origin_value
      );
    },
    resolveCode: true
  });
}

export function deleteResource(path) {
  return event.execute({
    max: 1,
    interval: 5000,
    noSession: true,
    step: 'deleteResource',
    executeFn() {
      return nativeInterface.deleteResource(path);
    },
    resolveCode: true
  });
}

export function getAppInfo() {
  return event.execute({
    max: 1,
    interval: 5000,
    noSession: true,
    step: 'getAppInfo',
    executeFn() {
      return nativeInterface.getAppInfo();
    },
    resolveCode: false
  });
}

function callback(...args) {
  event.emmitCallback(...args);
}

// 在web-interface.js文件中会设置window全局对象的回调供安卓调用
export const windowNativeCallback = {
  // 下载升级文件回调
  downloadUpgradeFileCallback: callback,
  // 删除资源回调
  deleteResourceCallback: callback,
  // app版本信息回调
  appInfoCallback: callback
};
